import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
	selector: 'kwo-search-input',
	templateUrl: './search-input.component.html',
	styleUrls: ['./search-input.component.scss'],
	host: { class: '' },
	standalone: true,
	imports: [CommonModule, FaIconComponent, ReactiveFormsModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchInputComponent implements OnInit, OnDestroy {

	public searchValue = new FormControl<string>('');

	constructor(private readonly router: Router) { }

	ngOnInit(): void {

	}

	submitSearch() {

		if (!this.searchValue.value) {
			return;
		}

		this.router.navigate(['/zoeken', this.searchValue.value])
	}

	ngOnDestroy(): void {
	}
}